import {
	TablePage,
	ViewPage,
	EditPage,
	AddPage
} from 'src/views/ping-admin/event-code'
import pathMap from 'src/paths/PathMap_Ping'

class PingEventCodeRoute {
	getConfigurations() {
		return [
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_LIST_VIEW,
				component: TablePage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_DETAILS_VIEW,
				component: ViewPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_EDIT_VIEW,
				component: EditPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_ADD_VIEW,
				component: AddPage
			}
		]
	}
}

export default PingEventCodeRoute
